import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { billingGroupApi } from '../../api/lib/billing-group';
import { discountHistoryKeys } from '../../api/query-keys/discount-history';

import { DiscountHistory } from '@/features/hosts/api/types/discount';
import { PaginatedResponse } from '@/types/responses/paginated-response';

export const useDiscountHistory = ({
  id,
  page,
  perPage,
}: {
  id: number;
  page: number;
  perPage: number;
}) => {
  return useQuery<PaginatedResponse<DiscountHistory>, ApiError>({
    queryKey: discountHistoryKeys.list(id, page, perPage),
    queryFn: () => billingGroupApi.fetchDiscountHistory(id, page, perPage),
  });
};
